module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc#p01"
    }
  }, [_vm._v("PART ONE:")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "part-subtitle"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc#p01"
    }
  }, [_vm._v("1499")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("If … we are to call any age golden, it is beyond doubt that age which brings forth golden talents in different places. That such is true of this our age he who wishes to consider the illustrious discoveries of this time will hardly doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Marsilio Ficino, 1492"), _c('span', {
    attrs: {
      "href": "#/OEBPS/enote#p01-sec1_ftn1",
      "id": "p01-sec1_fn1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("The night before his last Advent sermon, 1492, he beheld in the middle of the sky a hand bearing a sword, upon which these words were inscribed: "), _c('em', [_vm._v("‘Gladius Domini super terram cito et velociter.’")]), _vm._v(" He heard many clear and distinct voices promising mercy to the good, threatening chastisement to the wicked, and proclaiming that the wrath of God was at hand. Then, suddenly the sword was turned towards the earth; the sky darkened; swords, arrows, and flames rained down: terrible thunderclaps were heard; and all the world was a prey to war, famine, and pestilence. The vision ended with a command to Savonarola to make these things known to his hearers, to inspire them with the fear of God, and to beseech the Lord to send good shepherds to His Church, so that the lost sheep might be saved.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("P. Villari, "), _c('em', [_vm._v("Life and Times of Savonarola"), _c('span', {
    attrs: {
      "href": "#/OEBPS/enote#p01-sec2_ftn2",
      "id": "p01-sec2_fn2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18873f0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p01.vue
// module id = 81
// module chunks = 0